module.exports = __webpack_public_path__ + "img/100.hebrew.42d4bfc5.svg";